<template>
    <div class="section px-0 pb-5 pt-0" :class="{'px-5':noProjectsToShow}">
        <transition-group v-if="showMode=='LIST_MODE'"
            name="lb-project-list"
            tag="div"
            class="px-2"
            appear
        >
                <management-table-content
                :key="'table-content'"
                    :content="projects"
                    :labels="tableLabels"
                    :myfields="tableFields"
                    :myActions="tableActions"
                    :hideActions="true"
                    @SHOW="openShareModal"
                    @EDIT="selectProject"
                    @CLONE="clone"
                    @REMOVE="deleteProject"
                />
        </transition-group>
        <transition-group v-else
            name="lb-project-list"
            tag="div"
            class="columns is-multiline is-mobile mx-0"
            appear
        >
            <div
                v-for="project in projects"
                :key="project._id"
                tag="div"
                draggable="false"
                class="column is-12-mobile is-6-tablet is-4-desktop is-3-widescreen lb-project-card"
            >
                <dashboard-app-content-list-card
                    :content="project"
                    :myActions="tableActions"
                    @show-share-modal="openShareModal"
                    @toggle-listed="toggleListed"
                    @SHOW="openShareModal"
                    @EDIT="selectProject"
                    @CLONE="clone"
                    @REMOVE="deleteProject"
                />
            </div>
        </transition-group>
        <duplicate-project-modal
            v-if="showDuplicateModal"
            :project="project"
            @close="showDuplicateModal = false"
            @add-project="addProject"
        ></duplicate-project-modal>

        <project-modal-share
            v-if="showShareModal"
            :content="project"
            :library="library"
            :showViewButton="canView(project)"
            @close="showShareModal = false"
            @view="viewProject(project)"
            class="project-resume"
        ></project-modal-share>
    </div>
</template>

<script>
import DashboardAppContentListCard from '@/components/DashboardAppContentListCard';
import ManagementTableContent from '@/components/ManagementTableContent';
import ProjectModalShare from '@/components/ProjectModalShare';
import DuplicateProjectModal from '@/components/DuplicateProjectModal';
import { deleteItem, removeProjectFromFolder, manageAppList } from '@/services/API';
import _ from 'underscore';
import Swal from 'sweetalert2';
export default {
    components: {
        DashboardAppContentListCard,
        DuplicateProjectModal,
        ProjectModalShare,
        ManagementTableContent
    },
    props: {
        projects: {
            type: Array,
            default() {
                return [];
            },
        },
        library: {
            type: Boolean,
            default: false,
        },
        showMode: {
            type: String,
            default: 'CARDS_MODE',
        },
    },
    data() {
        return {
            showModal: false,
            showShareModal: false,
            project: null,
            showDuplicateModal: false,
            tableLabels: [
                'TITLE',
                'SHORTCODE',
                'FORMAT',
                'VIEWS'
            ],
            tableFields: [
                'title',
                'shortCode',
                'format',
                'viewsFromApp'
            ],
            tableActions: [
                
            ] ,
        };
    },
    computed: {
        noProjectsToShow(){
            return this.showCreationCard && !this.projects.length && !this.$route.params.folder;
        }
    },
    mounted() {
        // console.log("show creation card?", this.showCreationCard)

        // console.log("active plan", this.$store.getters.activePlan)
        // console.log("projects",this.projects)
        
    },
    methods: {
        isGame(project){
            if(project.format == 'PROJECT_TYPE_QUIZ' || project.format == 'PROJECT_TYPE_GEOQUIZ' || project.format == 'PROJECT_TYPE_QUIZHUNT' || project.format == 'PROJECT_TYPE_TREASUREHUNT'){
                return true;
            }else if(project.type=='trivial' || project.type=="treasurehunt"){
                return true;
            }
            return false;

        },
        selectProject(project) {
            this.project = project;
            if(!this.canAccessProject(project)){
                this.openShareModal(project);
            } else {
                const routeData = this.$router.resolve({name: 'project', params: { projectId: this.project._id }});
                window.open(routeData.href, '_blank');
                
            } 
        },
        canAccessProject(project){
            if(this.$store.getters.isLoggedIn && 
            !this.$store.getters.isAnonymous && 
            ((this.project.accessLevel && project.accessLevel != 'read') || project.defaultPermission!='read')
            ){
                return true;
            }else if((this.$store.getters.isAnonymous || !this.$store.getters.isLoggedIn) && project.allowAnonymous==true){
                return true;
            }
            return false;
        },
        canView(project){
            if(project.accessLevel == 'administrator'){
                return true;
            }
            if(project.format == 'PROJECT_TYPE_QUIZ' || project.format == 'PROJECT_TYPE_GEOQUIZ' || project.format == 'PROJECT_TYPE_QUIZHUNT'){
                return false;
            }else if(project.type=='trivial'){
                return false;
            }else if((project.format == 'PROJECT_TYPE_TREASUREHUNT' || project.type=='treasurehunt') && project.privacy != 'public' ){
                return false;
            }
            return true;
        },
        viewProject(project) {
            this.project = project;
            /*if (this.project.mode && this.project.mode == 'map') {
                this.$router.push({
                    name: 'project-view',
                    params: { projectId: this.project._id },
                });
            } else {*/
                this.$router.push({
                    name: 'project',
                    params: { projectId: this.project._id },
                });
           // }
        },
        async deleteProject(item) {

            Swal.fire({
                title: this.$t('delete_project_title') + " " + item.title,
                text: this.$t('delete_project_confirmation_message'),
                showCancelButton: true,
                confirmButtonText: this.$t('dropdown_option_delete_object'),
                cancelButtonText: this.$t('userProfile.leave_school_cancel'),
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteProjectAction(item);
                }
            });
        },
        async deleteProjectAction(item){
            let response = await deleteItem('project', item._id);
            if (response.data.success) {
                this.$emit('deleteProject', item._id);
            } else {
                console.error('impossible to delete project');
            }
        },
        async removeProjectFromFolder(project) {
            const projectIndex = _.findIndex(this.projects, {
                _id: project._id,
            });
            const splicedProject = this.projects.splice(projectIndex, 1);
            removeProjectFromFolder(project.folder._id, {
                project: project._id,
            }).catch(() => {
                this.projects.splice(projectIndex, 0, splicedProject[0]);
            });
        },
        dragStart(ev, project) {
            ev.dataTransfer.setData('project', project._id);
        },
        clone(project) {
            // console.log("try to clone ",project);
            this.project = project;
            this.showDuplicateModal = true;
        },
        addProject(data) {
            // console.log('projectsgrid');
            //this.projects.push(projectData);
            this.$emit('addProject',data);
        },
        openShareModal(project) {
            if (project.project) {
                this.project = project.project;
            } else {
                this.project = project;
            }
            
            this.showShareModal = true;
        },
        async toggleListed(project) {
            // console.log("project recived",project)
            let listedResult = await manageAppList(project.project ? 'session': 'project',project._id);
            //this.project = featuredResult.data;
            // console.log(listedResult.data)
            this.$emit("toggleListed",listedResult.data)
        }
    },
};
</script>

<style scoped>
@import '../assets/css/swal-eduloc.css';
.lb-creation-object .icon.is-large {
    height: 10rem;
    width: 10rem;
}
.mdi-10r {
    font-size: 10rem;
}
</style>
